import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_userCenter_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeCookie(val) {
    return Cookies.remove(val)
}
